export const environment = {
  production: true,
  apiRoot: 'https://sws-magicore-3d-api.azurewebsites.net/api/visualize-3d',
  throwOnQpdErrors: true,
};
